import { Component, OnInit } from '@angular/core';
import { GET_FAQS } from '../../../modules/accounts/admin/faq-management/faq.graphql';
import { FAQCategory, FAQ_CATEGORY_ORDER, normalizeFaqCategory } from '../../../modules/accounts/admin/faq-management/faq.model';
import { SharedModule } from '../../../shared/shared.module';
import { GraphqlService } from '../../../services/graphql.service';

@Component({
  selector: 'app-faq-section',
  imports: [SharedModule],
  templateUrl: './faq-section.component.html',
  styleUrl: './faq-section.component.scss',
})
export class FaqSectionComponent implements OnInit {
  faqs: { question: string; answer: string; category: FAQCategory }[] = [];
  activeIndex: number | null = null;
  selectedCategory: FAQCategory = FAQCategory.GENERAL;
  faqCategories: FAQCategory[] = [];

  constructor(private apollo: GraphqlService) {}

  async ngOnInit() {
    try {
      const result = await this.apollo.query({
        query: GET_FAQS,
        variables: {
          filtering: {
            isActive: true,
            isPublished: true,
            pageNumber: 1,
            pageSize: 100,
          },
        },
      });

      const items = result?.data?.getFaqs?.data || [];
      this.faqs = items.map((item: any) => ({
        question: item.question,
        answer: item.answer,
        category: normalizeFaqCategory(item.category),
      }));

      this.faqCategories = FAQ_CATEGORY_ORDER.filter((category) =>
        this.faqs.some((faq) => faq.category === category)
      );

      if (!this.faqCategories.includes(this.selectedCategory)) {
        this.selectedCategory = this.faqCategories[0] || FAQCategory.GENERAL;
      }
    } catch {
      this.faqs = [];
      this.faqCategories = FAQ_CATEGORY_ORDER.slice();
      this.selectedCategory = FAQCategory.GENERAL;
    }
  }

  get filteredFaqs() {
    return this.faqs.filter((faq) => faq.category === this.selectedCategory);
  }

  selectCategory(category: FAQCategory) {
    this.selectedCategory = category;
    this.activeIndex = null;
  }

  toggle(i: number) {
    this.activeIndex = this.activeIndex === i ? null : i;
  }
}